// src/components/Login.jsx
import AppURL from '../api/AppURL';

import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("test@gmail.com");
  const [password, setPassword] = useState("password");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    axios.post(AppURL.UserLogin, {
      email: email,
      password: password
    })
      .then(response => {
        localStorage.setItem('auth_token', response.data.token);
        onLogin();
      })
      .catch(error => {
        if (error.response?.status === 403) {
          setError("Please verify your email before logging in.");
        } else {
          setError("Invalid credentials");
        }
      });
  };

  return (
    <div className="container mt-5 pt-5">
      <h4>Login</h4>
      <form onSubmit={handleLogin}>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="form-control mb-2" placeholder="Email" />
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="form-control mb-2" placeholder="Password" />
        <button className="btn btn-primary">Login</button>
        <Link to="/forgot-password" className="btn btn-link text-decoration-none">Forgot Password?</Link>
        <Link to="/register" className="btn btn-outline-secondary ms-2">
          Create New Account
        </Link>
        {error && <div className="text-danger mt-2">{error}</div>}
      </form>
    </div>
  );
};

export default Login;
